var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9919 6.43689V5.62439C11.9919 5.29314 11.8637 4.97564 11.635 4.73689L9.265 2.26877C9.14552 2.14426 9.00209 2.04519 8.84335 1.97752C8.6846 1.90986 8.51381 1.87499 8.34125 1.87502H4.80937C4.19649 1.87271 3.60713 2.11077 3.16777 2.53808C2.72842 2.9654 2.47409 3.54793 2.45937 4.16064V10.7269C2.45257 11.0349 2.5065 11.3412 2.6181 11.6284C2.72969 11.9155 2.89676 12.1779 3.10976 12.4005C3.32276 12.623 3.57752 12.8015 3.8595 12.9256C4.14147 13.0497 4.44512 13.117 4.75312 13.1238H7.25437",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6425 1.91437V3.72187C8.6425 4.14557 8.81056 4.55196 9.1098 4.85191C9.40905 5.15187 9.81506 5.32088 10.2388 5.32187H11.9506",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 8.54189C12.225 8.79251 12.1631 9.07814 11.9688 9.26564C11.9688 9.26564 11.665 9.49439 11.6169 9.60751C11.555 9.75126 11.5469 10.0925 11.6169 10.2325C11.6875 10.3744 12.1231 10.6125 12.1231 10.6125C12.3869 10.81 12.5419 11.1213 12.5419 11.4513C12.5419 11.5634 12.4974 11.6709 12.4182 11.7502C12.339 11.8296 12.2315 11.8742 12.1194 11.8744H9.23813C9.12585 11.8744 9.01816 11.8298 8.93871 11.7505C8.85926 11.6712 8.81454 11.5635 8.81438 11.4513C8.81438 11.1213 8.97063 10.81 9.23438 10.6125C9.23438 10.6125 9.66938 10.3744 9.74063 10.2325C9.81063 10.0925 9.80125 9.75126 9.74063 9.60751C9.6925 9.49439 9.3875 9.26564 9.3875 9.26564C9.29232 9.17345 9.22682 9.05496 9.19939 8.92532C9.17196 8.79569 9.18384 8.66082 9.23351 8.53798C9.28318 8.41514 9.36839 8.30992 9.47822 8.23579C9.58805 8.16167 9.7175 8.122 9.85 8.12189H11.5063C11.7788 8.12251 12.0238 8.28876 12.125 8.54189Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6788 11.875V13.1256M6.87626 8.81811H5.14688M6.07626 6.23749H5.14626",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.48a5feac91cae65004d12e34a0121adb.svg";
export { ForwardRef as ReactComponent };